<template>
    <modal name="validation">
      <h1 class="text-xl font-bold mb-8 light-blue">Age Error</h1>
      <p class="mb-4">Please correct the individual's year of birth</p>
      <p class="mb-4">this is a key field for their use of the Connections App.</p>
      <button class="w-24" @click="closeModal">Close</button>
    </modal>
  </template>
  <script>
  
  export default {
    name: 'ValidationModal',
    created() { /* Called synchronously after the instance is created */ },
    mounted() { /* Called after the instance has been mounted */ },
    methods: { // component functions
      closeModal() {
        this.$modal.hide('validation');
      }
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
    button {
      height: 40px;
      font-size: 14px;
      color: #fff;
      border: none;
      padding: 6px 12px;
      border-radius: 40px;
      background: #319af1;
    }
      button.send {
        border-radius: 4px;
      }
    .light-blue {
      color: #319af1;
    }
    input {
      font-size: 14px;
      font-weight: 400;
      color: #333;
      height: 40px;
      border-radius: 4px;
      padding: 6px 12px;
      line-height: 1.42857143;
      border: 1px solid #ccc;
      -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
      box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%);
      -webkit-transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
      -o-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
      transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
    }
      input:focus {
        border-color: #66afe9;
        outline: 0;
        -webkit-box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%), 0 0 8px rgb(102 175 233 / 60%);
        box-shadow: inset 0 1px 1px rgb(0 0 0 / 8%), 0 0 8px rgb(102 175 233 / 60%);
      }
  </style>
  
  <!-- Not "scoped" to style modal -->
  <style>
    .vm--container {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .vm--overlay {
      background: rgba(8, 17, 53, 0.38) !important;
    }
    .vm--modal {
      text-align: center;
      border-radius: 4px !important;
      background: #ffffff;
      padding: 20px;
      height: auto !important;
      width: auto !important;
      max-width: 600px;
      top: auto !important;
      left: auto !important;
    }
  </style>